module.exports = __webpack_public_path__ + "img/33.4522c314.png";